import Vue from 'vue'
import { DAY } from '@shared/utils/storage'
import { StorageService } from './storage'


export const StagesService = StorageService.extend({
  key: '#calendar-stages',
  storageParams: { expired: DAY },

  urls: {
    STAGES_LIST: '/api/stages/list/',
    STAGE: '/api/stages/:order/',
    STAGE_INITIALIZE: '/api/stages/init/',
    STAGE_SHIFT: '/api/stages/:order/shift/',

    SYNC: '/api/calendar-sync/',
    SHARE_LIST: '/share/feedings/?date_from=:date_from&date_to=:date_to&stage=:stage',
    SHARE_TABLE: '/share/calendar/?date_from=:date_from&date_to=:date_to&stage=:stage',
  },

  data() {
    return {
      stages_list: {},
      stages: {},
    }
  },

  methods: {
    getStages(cached=true) {
      if (!cached) {
        this.stages_list = {}
      }

      return this.retreiveCollection(
        this.getUrl('STAGES_LIST'), 'stages_list'
      )
    },

    getCurrent(cached=true) {
      return this.getStages(cached).then(stages => {
        stages = stages.sort((a, b) => a.order - b.order)

        return { stages, current: stages.find(x => x.status === 'active') }
      })
    },

    getStage(order) {
      return this.retreiveCollectionItem(
        this.getUrl('STAGE', { order }), 'stages', order
      )
    },

    getSwitchableStages() {
      if (!(this.stages_list && this.stages_list.length > 0)) {
        if (this.loading == 0) {
          this.getStages()
        }

        return []
      }

      return this.stages_list.filter(
        x => x.status == 'active' || x.is_history
      )
    },

    setStage(stage) {
      this.setCollectionItem('stages', stage.order, stage)
      this.stages_list = {}
    },

    initializeStage(config) {
      this.stages = {}
      this.stages_list = {}

      this.$emit('initializeStage', config)

      return this.sendData(
        this.getUrl('STAGE_INITIALIZE'),
        config,
        data => {
          this.setCollectionItem('stages', data.order, data)
          this.stages_list = {}
        }
      )
    },

    shiftStage(order, date_from, date_to) {
      return this.sendData(
        this.getUrl('STAGE_SHIFT', { order }),
        { date_from, date_to },
        data => {
          this.setCollectionItem('stages', order, data)
          this.stages_list = {}
        }
      )
    },

    sync() {
      return this.getData(this.getUrl('SYNC'))
    },

    list(params) {
      return this.getData(this.getUrl('SHARE_LIST', params))
    },

    table(params) {
      return this.getData(this.getUrl('SHARE_TABLE', params))
    }
  }
})

export const stagesService = new StagesService({})



// WEBPACK FOOTER //
// ./src/js/shared/services/stages.js